module.exports = __webpack_public_path__ + "a2e73be94d973db0d87f410aa5bcddd4.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/head/goldencity3.jpg
// module id = 632
// module chunks = 0